import { Controller } from "@hotwired/stimulus"

// Language picker. Each <option> carries the destination URL, so picking one
// lands on the same screen the old English/Arabic link did.
//
// The navigation is a hard load, not a Turbo visit: switching language has to
// rebuild the whole shell, exactly like the English/Arabic switch does. For
// en/ar the native side restarts the navigator on its own (LanguageManager
// only recognises those two segments); for every other locale the full reload
// is what replaces the cached, previous-language markup.
export default class extends Controller {
  visit() {
    const url = this.element.value
    if (url) window.location.assign(url)
  }
}
